var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3866 13.9999C16.3866 15.3199 15.3199 16.3866 13.9999 16.3866C12.6799 16.3866 11.6133 15.3199 11.6133 13.9999C11.6133 12.6799 12.6799 11.6133 13.9999 11.6133C15.3199 11.6133 16.3866 12.6799 16.3866 13.9999Z",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 19.5138C16.3532 19.5138 18.5466 18.1271 20.0732 15.7271C20.6732 14.7871 20.6732 13.2071 20.0732 12.2671C18.5466 9.86713 16.3532 8.48047 13.9999 8.48047C11.6466 8.48047 9.45323 9.86713 7.92656 12.2671C7.32656 13.2071 7.32656 14.7871 7.92656 15.7271C9.45323 18.1271 11.6466 19.5138 13.9999 19.5138Z",
    stroke: "#004EFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEye);
export default __webpack_public_path__ + "static/media/blueEye.f42eb2acaefb8cb8418a72640706e62c.svg";
export { ForwardRef as ReactComponent };